import { Box, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";

function InsuranceBillingSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Insurance & Billing Information
      </Typography>

      <Box className="grid grid-cols-2 gap-4">
        <Controller
          name="insuranceNumber"
          control={control}
          render={({ field }) => (
            <TextField
              id="insurance-number"
              label="Insurance Number"
              variant="outlined"
              fullWidth
              error={!!errors.insuranceNumber}
              helperText={errors.insuranceNumber?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="insuranceProvider"
          control={control}
          render={({ field }) => (
            <TextField
              id="insurance-provider"
              label="Insurance Provider"
              variant="outlined"
              fullWidth
              error={!!errors.insuranceProvider}
              helperText={errors.insuranceProvider?.message as string}
              {...field}
            />
          )}
        />
      </Box>
    </Box>
  );
}

export default InsuranceBillingSection;
